import {
  IonButton,
  IonCol,
  IonGrid,
  IonItem,
  IonLabel,
  IonList,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonSkeletonText,
  IonToast,
  IonToggle,
} from "@ionic/react";
import { Link } from "react-router-dom";
import { URLS } from "../../urls";
import {
  calcScorePerUserForGame,
  calcScorePerUserForTournament,
  getTournamentGames,
  sortByProp,
} from "../../calcScore";
import React, { Component } from "react";
import "./style.css";
import Bets from "../Bets";
import Avatar from "awesome-react-avataaars";
import { avatarOptions } from "../../avataaars";

declare const Array: any;
Array.prototype.idx = function (idx) {
  return this[idx % this.length];
};

type MyProps = {
  data: any;
  users: any;
  userBets: any;
  tournamentID: string;
  gameID: string;
  rowsNum: number;
  uid: string;
  showID: boolean;
  showBets: boolean;
  isEditor: boolean;
  filterActivity: boolean;
};

class Leadboard extends Component<MyProps> {
  state = {
    data: this.props.data,
    users: this.props.users,
    userBets: this.props.userBets,
    gameID: this.props.gameID,
    tournamentID: this.props.tournamentID,
    rowsNum: this.props.rowsNum,
    openToast: false,
    showBets: false,
  };

  public static defaultProps = {
    rowsNum: 10,
    showID: false,
    showBets: false,
    isEditor: false,
    filterActivity: false,
    userBets: {},
  };

  static getDerivedStateFromProps(props, current_state) {
    return {
      tournamentID: props.tournamentID,
      gameID: props.tournamentID !== current_state.tournamentID ? "total" : current_state.gameID,
      data: props.data,
      users: props.users,
      userBets: props.userBets,
      rowsNum: props.rowsNum === -1 ? Number.MAX_SAFE_INTEGER : props.rowsNum,
    };
  }

  getUsersSort = () => {
    const users = this.state.users;
    const usersSort: any = [];
    for (let uid in users) {
      let userScore =
        this.state.gameID === "total"
          ? calcScorePerUserForTournament(this.state.data, users[uid].scores, this.state.tournamentID)
          : calcScorePerUserForGame(users[uid].scores, this.state.gameID);

      if (Number.isInteger(userScore) || !this.props.filterActivity)
        usersSort.push({
          ...users[uid],
          ...{
            uid,
            score: userScore ?? 0,
          },
        });
    }
    sortByProp(usersSort, "score", false);
    return usersSort;
  };

  copyToClipboard = (str) => {
    const el = document.createElement("textarea");
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  };

  render() {
    var myIndex = -1;
    var myUser: any = {};
    const usersSort = this.getUsersSort();

    for (let i = 0; i < usersSort.length; i++) {
      if (usersSort[i].uid === this.props.uid) {
        myIndex = i;
        myUser = usersSort[i];
      }
    }
    return (
      <div style={{ marginRight: "15px", marginLeft: "15px" }}>
        <IonList className={"leadboard__list" + (this.props.showID ? " leadboard__list_wide" : "")}>
          <IonItem style={{ "--background-hover": "none", "--ripple-color": "transparent" }}>
            <IonGrid>
              <IonRow>
                <IonCol className="leadboard__col1">
                  <IonLabel className="leadboard__label">
                    {this.props.showBets ? (
                      <IonToggle
                        checked={this.state.showBets}
                        onIonChange={(e) => {
                          this.setState({ showBets: e.detail.checked });
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </IonLabel>
                </IonCol>
                <IonCol className="leadboard__col2">
                  <IonLabel className="leadboard__label">שם משתמש</IonLabel>
                </IonCol>
                <IonCol className="leadboard__col3" style={{ maxWidth: "100px" }}>
                  <IonSelect
                    id="leadboard__selectScore"
                    className="leadboard__selectScore"
                    interface="popover"
                    value={this.state.gameID}
                    title={this.state.gameID === "total" ? "" : this.state.data.Games[this.state.gameID].description}
                    onIonChange={(e: any) => {
                      const gameID = e.detail.value;
                      this.setState({ gameID });
                      this.forceUpdate();
                    }}
                  >
                    <IonSelectOption value="total">ניקוד כולל</IonSelectOption>
                    {getTournamentGames(this.state.data, this.state.tournamentID).map((value: any, index: any) => {
                      if (this.props.isEditor || new Date(value.firstTimeToBet) <= new Date())
                        return (
                          <IonSelectOption value={value.gameID} key={"game" + value.gameID}>
                            {value.description}
                          </IonSelectOption>
                        );
                    })}
                  </IonSelect>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonItem>
          {usersSort.slice(0, this.state.rowsNum).map((value: any, index: any) => {
            return (
              <div key={"item" + index}>
                <Link
                  to={URLS.USER.url + "/" + value.uid + "?tournamentID=" + this.state.tournamentID}
                  onClick={(e) => {
                    if (this.props.showID) e.preventDefault();
                  }}
                >
                  <IonItem className="leadboard__item">
                    <IonGrid>
                      <IonRow
                        className={"leadboard__row" + (index + 1) + (value === myUser ? " leadboard__myrow" : "")}
                      >
                        <IonCol className="leadboard__col1">
                          <IonLabel className="leadboard__label">{index + 1}.</IonLabel>
                        </IonCol>
                        <IonCol className="leadboard__col2">
                          <IonLabel className="leadboard__label">
                            <Avatar
                              style={{
                                width: "25px",
                                height: "25px",
                                marginLeft: "10px",
                              }}
                              avatarStyle="Circle"
                              clotheColor={value.avatar?.clotheColor ?? avatarOptions.clotheColor.idx(index)}
                              graphicType={value.avatar?.graphicType ?? avatarOptions.graphicType.idx(index)}
                              hatColor={value.avatar?.hatColor ?? avatarOptions.hatColor.idx(index)}
                              topType={value.avatar?.topType ?? avatarOptions.topType.idx(index)}
                              accessoriesType={
                                value.avatar?.accessoriesType ?? avatarOptions.accessoriesType.idx(index)
                              }
                              hairColor={value.avatar?.hairColor ?? avatarOptions.hairColor.idx(index)}
                              facialHairType={value.avatar?.facialHairType ?? avatarOptions.facialHairType.idx(index)}
                              facialHairColor={
                                value.avatar?.facialHairColor ?? avatarOptions.facialHairColor.idx(index)
                              }
                              clotheType={value.avatar?.clotheType ?? avatarOptions.clotheType.idx(index)}
                              eyeType={value.avatar?.eyeType ?? avatarOptions.eyeType.idx(index)}
                              eyebrowType={value.avatar?.eyebrowType ?? avatarOptions.eyebrowType.idx(index)}
                              mouthType={value.avatar?.mouthType ?? avatarOptions.mouthType.idx(index)}
                              skinColor={value.avatar?.skinColor ?? avatarOptions.skinColor.idx(index)}
                            />
                            {value.nickname}
                          </IonLabel>
                        </IonCol>
                        <IonCol className="leadboard__col3">
                          <IonLabel className="leadboard__label">{value.score}</IonLabel>
                        </IonCol>
                        {this.props.showID ? (
                          <IonCol className="leadboard__col2">
                            <IonButton
                              onClick={() => {
                                this.copyToClipboard(value.uid);
                                this.setState({ openToast: true });
                              }}
                            >
                              {value.uid}
                            </IonButton>
                          </IonCol>
                        ) : (
                          ""
                        )}
                      </IonRow>
                    </IonGrid>
                  </IonItem>
                </Link>
                {this.state.showBets ? (
                  <Bets
                    data={this.state.data}
                    userBets={this.state.userBets[value.uid]}
                    userScores={value.scores}
                    tournamentID={this.state.tournamentID}
                    showPlayers
                  />
                ) : (
                  ""
                )}
              </div>
            );
          })}

          {myIndex >= this.state.rowsNum ? (
            <Link to={URLS.USER.url + "/" + this.props.uid + "?tournamentID=" + this.state.tournamentID}>
              <IonItem className="leadboard__item">
                <IonGrid>
                  <IonRow className="leadboard__myrow">
                    <IonCol className="leadboard__col1">
                      <IonLabel className="leadboard__label">{myIndex + 1}.</IonLabel>
                    </IonCol>
                    <IonCol className="leadboard__col2">
                      <IonLabel className="leadboard__label">
                        <Avatar
                          style={{
                            width: "25px",
                            height: "25px",
                            marginLeft: "10px",
                          }}
                          avatarStyle="Circle"
                          clotheColor={myUser.avatar?.clotheColor ?? avatarOptions.clotheColor.idx(myIndex)}
                          graphicType={myUser.avatar?.graphicType ?? avatarOptions.graphicType.idx(myIndex)}
                          hatColor={myUser.avatar?.hatColor ?? avatarOptions.hatColor.idx(myIndex)}
                          topType={myUser.avatar?.topType ?? avatarOptions.topType.idx(myIndex)}
                          accessoriesType={myUser.avatar?.accessoriesType ?? avatarOptions.accessoriesType.idx(myIndex)}
                          hairColor={myUser.avatar?.hairColor ?? avatarOptions.hairColor.idx(myIndex)}
                          facialHairType={myUser.avatar?.facialHairType ?? avatarOptions.facialHairType.idx(myIndex)}
                          facialHairColor={myUser.avatar?.facialHairColor ?? avatarOptions.facialHairColor.idx(myIndex)}
                          clotheType={myUser.avatar?.clotheType ?? avatarOptions.clotheType.idx(myIndex)}
                          eyeType={myUser.avatar?.eyeType ?? avatarOptions.eyeType.idx(myIndex)}
                          eyebrowType={myUser.avatar?.eyebrowType ?? avatarOptions.eyebrowType.idx(myIndex)}
                          mouthType={myUser.avatar?.mouthType ?? avatarOptions.mouthType.idx(myIndex)}
                          skinColor={myUser.avatar?.skinColor ?? avatarOptions.skinColor.idx(myIndex)}
                        />
                        {myUser.nickname}
                      </IonLabel>
                    </IonCol>
                    <IonCol className="leadboard__col3">
                      <IonLabel className="leadboard__label">{myUser.score}</IonLabel>
                    </IonCol>
                    {this.props.showID ? (
                      <IonCol className="leadboard__col2">
                        <IonButton
                          onClick={() => {
                            this.copyToClipboard(myUser.uid);
                            this.setState({ openToast: true });
                          }}
                        >
                          {myUser.uid}
                        </IonButton>
                      </IonCol>
                    ) : (
                      ""
                    )}
                  </IonRow>
                </IonGrid>
              </IonItem>
            </Link>
          ) : (
            <div />
          )}
          {usersSort.length === 0
            ? Array.from(Array(this.state.rowsNum === Number.MAX_SAFE_INTEGER ? 10 : this.state.rowsNum).keys()).map(
                (i: any) => {
                  return (
                    <IonItem key={"skeleton" + i}>
                      <IonSkeletonText animated />
                    </IonItem>
                  );
                }
              )
            : ""}
        </IonList>
        <IonToast
          isOpen={this.state.openToast}
          onDidDismiss={() => this.setState({ openToast: false })}
          duration={1000}
          message="Copied to clipboard"
        />
      </div>
    );
  }
}
export default Leadboard;
